export const antdProTableRequestHandler = ({
  pagination,
  setPagination,
  setSortingCriteria,
  items,
  totalCount,
}: $TSMigrationFixMe) => {
  return async (params: $TSMigrationFixMe, sort: string[]) => {
    const sortKey = Object.keys(sort)[0]
    const sortValue = Object.values(sort)[0]
    setPagination({
      ...pagination,
      skipCount: (params.current - 1) * params.pageSize,
      itemsPerPage: params.pageSize,
    })
    setSortingCriteria?.({
      property: sortKey,
      sort:
        sortValue === "ascend"
          ? "ASC"
          : sortValue === "descend"
          ? "DESC"
          : null,
    })
    return {
      data: items,
      success: !!items,
      total: totalCount,
    }
  }
}
